<div class="grid-header" [ngStyle]="{ '--grid-columns': isProductFilterVisible() ? '1fr 1fr 2fr' : '1fr 2fr' }">
	<mat-form-field>
		<mat-icon matPrefix>search</mat-icon>
		<input
			matInput
			#filter
			placeholder="{{ 'Search' | translate }}"
			[value]="gridState().filter"
			data-cy="dashboard-search"
		/>
		@if (gridState().filter) {
			<button
				class="clear-button"
				matSuffix
				mat-icon-button
				(click)="onFilterChange(''); $event.stopPropagation()"
				data-cy="text-filter-clear-button"
			>
				<mat-icon>close</mat-icon>
			</button>
		}
	</mat-form-field>
	@if (isProductFilterVisible()) {
		<mat-form-field subscriptSizing="dynamic">
			<mat-label>{{ "Product" | translate }}</mat-label>
			<mat-select
				multiple
				panelClass="taller-select"
				[(value)]="gridState().productFilter"
				(selectionChange)="onProductSelection($event.value)"
				data-cy="product-filter-select"
			>
				@if(hasProfessionalTreatment()) {
					<mat-option value="{{ ProductKey.PRO_SMILE_SCHIENE }}">{{ "Professional" | translate }}</mat-option>
				}
				@if(hasFunctionALTreatment()) {
					<mat-option value="{{ ProductKey.FUNCTIONAL_SCHIENE_NEO }}">{{ "FUNCTIONAL" | translate }}</mat-option>
				}
				@if(hasMemotainTreatment()) {
					<mat-option value="{{ ProductKey.MEMOTAIN }}">{{
						"MEMOTAIN®" | translate
					}}</mat-option>
				}
				@if(hasPeekRetainerTreatment()) {
					<mat-option value="{{ ProductKey.PEEK_RETAINER }}">{{
						"MEMOTAIN® Peek 3D" | translate
					}}</mat-option>
				}
				@if(hasRetentionsschieneTreatment()) {
					<mat-option value="{{ ProductKey.RETENTIONSSCHIENE }}">{{
						"MEMOTAIN® Clear" | translate
					}}</mat-option>
				}
				@if(hasCaseAssessmentTreatment()) {
					<mat-option value="{{ ProductKey.PRO_CASE_ASSESSMENT_SCHIENE }}">{{
						"Case Assessment" | translate
					}}</mat-option>
				}
				@if(otherProductKeys.length > 0) {
					<mat-option value="{{ OTHER_PRODUCTS_FILTER_KEY }}">{{ "Other" | translate }}</mat-option>
				}
			</mat-select>

			@if (!!gridState().productFilter?.length) {
				<button
					class="clear-button"
					matSuffix
					mat-icon-button
					(click)="onProductSelection([]); $event.stopPropagation()"
					data-cy="product-filter-clear-button"
				>
					<mat-icon>close</mat-icon>
				</button>
			}
		</mat-form-field>
	}
	<mat-paginator
		[length]="gridState().length"
		[pageSize]="gridState().pageSize"
		[pageSizeOptions]="paginationProps.pageSizeOptions"
		[showFirstLastButtons]="true"
		(page)="onPageEvent($event)"
	>
	</mat-paginator>
</div>
